// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__UPywp","mypic":"style_mypic__xEAzH","aboutme":"style_aboutme__Evb2f","tools":"style_tools__Nmyp+"};